/*
 * 项目公用接口
 */

import { post, get, postFormData } from 'api/http'
// import storage from 'src/unit/storage'
// import config from 'src/common/config'

export default {
    // 获取字典
    getDataDict(data) {
        return get('/common/dataDict', data, 'javaHost')
    },

    // 上传附件
    uploadFiles(data) {
        return postFormData('/attachment', data)
    },

    // 审核初始化
    verifyWorkInit(data) {
        // return post('/workflow/init', data)
        return post('/workflow/init', data, 'javaHost')
    },

    // 审核提交
    verifySubmit(data) {
        // return post('/workflow/submit', data)
        return post('/onlineReport/submit', data, 'javaHost')
    },

    // 审核转办
    verifyTransfer(data) {
        // return post('/workflow/transfer', data)
        return post('/workflow/operation', data, 'javaHost')
    },

    // 审核拒绝
    verifyReject(data) {
        // return post('/workflow/reject', data)
        return post('/workflow/operation', data, 'javaHost')
    },

    // 审核通过
    verifyAgree(data) {
        // return post('/workflow/agree', data)
        return post('/workflow/operation', data, 'javaHost')
    },

    // 审核日志
    verifyLog(data) {
        // return get('/workflow/logging', data)
        return get('/workflow/getWorkflowLogging', data, 'javaHost')
    },

    // 角色字典
    getRoleDict(data) {
        // return get('/project_role', data)
        return get('/projectRole/maintenance/findProjectRole', data, 'javaHost')
    },

    // 项目权限
    getProjectPermission(data) {
        return get('/project_permission', data)
    },

    // 建筑设施内容
    getBuildingContentType(data) {
        return get('/app/customer/sys_info', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/common.js